import { kebabify } from '@toasttab/shared/src/utils/stringUtils'

const heapAnalytics = (heapObject: object) => {
  if (typeof window === 'undefined') return

  let attempts = 0
  const maxAttempts = 10

  const waitForHeap = () => {
    if (window.heap && window.heap.loaded) {
      window.heap.addEventProperties(heapObject)
      window.heap.addUserProperties(heapObject)
      window.heap.track('Heap Analytics Initialized', heapObject) // Optional event name
    } else if (attempts++ < maxAttempts) {
      setTimeout(waitForHeap, 500)
    } else {
      console.warn('Heap not ready after multiple attempts.')
    }
  }

  waitForHeap()
}

export const addCustomEvent = (
  ...args: [name: string, properties?: Record<string, any>]
) => {
  // @ts-ignore
  if (window.heap?.track) {
    // @ts-ignore
    window.heap.track(args[0], args[1])
  }
}

export type TrackEventProps = {
  name: string
  properties?: Record<string, string | number | boolean | undefined>
}

export const trackEvent = ({
  name,
  properties,
  trackingPrefix
}: TrackEventProps & { trackingPrefix: string }) => {
  addCustomEvent(`${trackingPrefix}-${kebabify(name)}`, properties)
}

export default heapAnalytics
